import * as React from 'react'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'
import * as st from './pageUnavailable.module.scss'

export const PageUnavailable = () => (
  <MessageWrapper stringID={StringId.DV_DP_unavailable_page_message} />
)

export const OnlyPlaybackAvailableInGen4Message = () => (
  <MessageWrapper stringID={StringId.DV_DP_only_playback_available_in_gen4_message} />
)

interface IMessageWrapperProps {
  stringID: StringId
}

export const MessageWrapper = ({ stringID }: IMessageWrapperProps) => (
  <p className={`${st.message} avu-full-width`}><TextLocalizer stringID={stringID} /></p>
)